import { render, staticRenderFns } from "./pv.vue?vue&type=template&id=bc77b8aa&scoped=true&"
import script from "./pv.vue?vue&type=script&lang=js&"
export * from "./pv.vue?vue&type=script&lang=js&"
import style0 from "./pv.vue?vue&type=style&index=0&id=bc77b8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc77b8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc77b8aa')) {
      api.createRecord('bc77b8aa', component.options)
    } else {
      api.reload('bc77b8aa', component.options)
    }
    module.hot.accept("./pv.vue?vue&type=template&id=bc77b8aa&scoped=true&", function () {
      api.rerender('bc77b8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/pv.vue"
export default component.exports